export const basicModules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "link"],
    // [
    //   { list: "ordered" },
    //   { list: "bullet" },
    //   { indent: "-1" },
    //   { indent: "+1" },
    // ],
    [{ color: [] }, { background: [] }],
    ["clean"],
  ],
};

export const commentModules = {
  toolbar: [
    ["bold", "italic", "underline", "strike", "link"],
    [{ color: [] }, { background: [] }],
    ["clean"],
  ],
};
